export const LIST_URL_AKUNTANSI = {
  coa: {
    get: "/ms/coa/coa/listcoa_full",
    getbycode: "/ms/coa/coa/namebycode",
    delete: "/ms/coa/coa/delete",
    add: "/ms/coa/coa/create",
    update: "/ms/coa/coa/update",
    getByLevel: "/ms/coa/coa/readbylevel",
  },

  tipe_penerima: {
    list: "/ms/static/tipe_penerima/list",
    add: "/ms/static/tipe_penerima/create",
    update: "/ms/static/tipe_penerima/update",
    delete: "/ms/static/tipe_penerima/delete",
  },

  tipe_gl: {
    list: "/ms/static/tipe_ledger/list",
    add: "/ms/static/tipe_ledger/create",
    update: "/ms/static/tipe_ledger/update",
    delete: "/ms/static/tipe_ledger/delete",
  },

  periode: {
    list: "/ms/static/periode/list-filter",
    add: "/ms/static/periode/create",
    update: "/ms/static/periode/update",
    delete: "/ms/static/periode/delete",
  },

  jurnal_umum: {
    // gudang: "/wmsfarmasi/gudang/list",
    gudang: "/wmsmaster/gudang/list-all",
    tipe_penerima: "/ms/static/tipe_penerima/list",
    supplier: "/wmsmaster/supplier/read_po_farmasi",
    perusahaan: "/company/listcompany",
    asuransi: "/insurance/listinsurance",
    dokter: "/doctor/listdoctor_regrj",
    user: "/users/listuser",

    register: "/ts/transaksi/register-accounting",
  },
};
